module.exports = __webpack_public_path__ + "media/home/Home-FramedMosaic-ee947171.jpg";